import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable, Subscription } from 'rxjs';
import { TaskModel } from 'src/app/core/models/task/task.model';
import { SecurityOperations } from 'src/app/core/security/security-operations';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { OpenModalService } from 'src/app/core/services/modal-services/open-modal.service';
import { PdfViewerModalService } from 'src/app/core/services/modal-services/pdf-viewer-modal.service';
import { TaskModalService } from 'src/app/core/services/modal-services/task-modal.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { ImportEntitiesListService } from 'src/app/core/services/list-services/import-entities-list.service';
import { EntityTypeEnum } from 'src/app/core/enums/entity-type-id-enum';
import { ImportEntityModel } from 'src/app/core/models/import/import-entity.model';
import Swal from 'sweetalert2';
import { EntityFileModel } from 'src/app/core/models/file/entity-file-model';
import { ListLayoutExtendableComponent } from '../list-layout/list-layout-extendable/list-layout-extendable.component';
import { ListFilterModel } from 'src/app/core/models/table/list-filter.model';
import { TableActionsModel } from 'src/app/core/models/table/table-action.model';
import { TableConfigurationModel } from 'src/app/core/models/table/table-configuration.model';
import { ServiceData } from 'src/app/core/models/table/service-data.model';
import { ImportEntitiesListConfig } from './import-entities-lift.config';
import { EmitSortModel } from 'src/app/core/models/table/emit-sort.model';
import { SortByTypeEnum } from 'src/app/core/enums/list-layout/sort-type-enum';
import { ContactListSortBy } from 'src/app/core/enums/sort-by-options/contact-list-sort-enum';
import { ActionIdEnum } from 'src/app/core/enums/list-layout/action-id-enum';
import { ButtonIdEnum } from 'src/app/core/enums/list-layout/button-id-enum';


@Component({
  selector: 'app-import-entities',
  templateUrl: './import-entities.component.html',
  styleUrls: ['./import-entities.component.scss']
})
export class ImportEntitiesComponent extends ListLayoutExtendableComponent {

  enumFilterType = [
    { value: undefined, text: "All Types" },
    { value: EntityTypeEnum.Client, text: $localize`:@@:Clients` },
    { value: EntityTypeEnum.Account, text: $localize`:@@:Contacts` }
  ]

  tableConfig: TableConfigurationModel = new TableConfigurationModel();
  serviceData: ServiceData = new ServiceData();

  override listItemsObservable!: Observable<TaskModel[]>;

  //Security Operations of the current User
  securityPermissionInvoiceUpdate: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.requisition.requisitionCreateInvoice);

  protected override searchPlaceHolderText: string = "Search for client number, name, or email";

  constructor(
    protected taskModalService: TaskModalService,
    protected importEntitiesListService: ImportEntitiesListService,
    protected override myFileApiService: MyfileApiService,
    protected override sanitizer: DomSanitizer,
    protected override pdfModalService: PdfViewerModalService,
    protected override authMyFileService: AuthMyfileService,
    protected override openModalService: OpenModalService,
    protected override toasterNotificationService: ToasterNotificationService,
  ) {
    super(myFileApiService, sanitizer, pdfModalService, authMyFileService, toasterNotificationService, openModalService);
  }

  ngOnInit(): void {

    this.tableConfig = new ImportEntitiesListConfig();

    this.listItemsObservable = this.importEntitiesListService.resultItems$;
    this.total = this.importEntitiesListService.total$;
    this.isLoading = this.importEntitiesListService.loading$;

    const subscr = this.isLoading.subscribe(result => {
      if (result) {
        this.serviceData.loadingValue = true;
      } else {
        this.serviceData.loadingValue = false;
      }
    });
    this.unsubscribe.push(subscr);

    const subscr2 = this.listItemsObservable.subscribe(result => {
      this.listItems = Object.assign([], result);
      this.listItems.forEach((entityModel: EntityFileModel) => {
        this.getEntityPhoto(entityModel, EntityTypeEnum.ImportEntity);
      });
    });
    this.unsubscribe.push(subscr2);

    const subscr3 = this.total.subscribe(result => {
      this.serviceData.totalRecords = this.importEntitiesListService.totalRecords;
      this.serviceData.pageSize = this.importEntitiesListService.pageSize;
      this.serviceData.pageIndex = this.importEntitiesListService.pageIndex;
    });
    this.unsubscribe.push(subscr3);
  }

  ngOnDestroy() {
    this.clearSearch(this.importEntitiesListService);
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  //** new simpler sort function for further lists with new layout component */
  sortByPassedSort(passedSortModel: EmitSortModel) {
    if (passedSortModel.sortSelected == SortByTypeEnum.None) {
      this.serviceSort(this.importEntitiesListService, '', '');
    } else {
      this.serviceSort(this.importEntitiesListService, passedSortModel.fieldName, passedSortModel.sortSelected);
    }
  }

  buttonActionSelected(buttonAction: any) {
    switch (buttonAction) {
      case  ButtonIdEnum.Import:
        this.importModels(); 
        break;
    }
  }

  override rowActionSelected(rowAction: TableActionsModel) {
    switch (rowAction.actionIdSelected) {
      case ActionIdEnum.Import:
        this.importEntity(rowAction.model,undefined);
        break;
      case ActionIdEnum.Edit:
        this.openModel(rowAction.model.entityType, rowAction.model.models[0], rowAction.model.models[0])
        break;
    }
  }

  filterSelected(filterSelected: ListFilterModel): void {
    switch (filterSelected.label) {
      case "type":
        this.importEntitiesListService.entityType = filterSelected.selectedOption as any;
      break;
    }
  }


  openModel(entityType: EntityTypeEnum, model: any, data: any) {
    switch (entityType) {
      case EntityTypeEnum.Client:
        var viewModel = { ...model }
        if (viewModel.dateOfBirth != undefined) {
          viewModel.dateOfBirth = this.dateRename(viewModel.dateOfBirth);
        }
        if (viewModel.dateOfLoss != undefined) {
          viewModel.dateOfLoss = this.dateRename(viewModel.dateOfLoss);
        }
        if (viewModel.profilePhotoFileId) {
          viewModel.id = data.id;
          viewModel.profilePhotoFileId = data.profilePhotoFileId;
        }
        this.openModalService.openClientModal(viewModel, undefined, undefined, undefined, undefined, true, EntityTypeEnum.ImportEntity);
        break;
      case EntityTypeEnum.Account:
        var viewModel = { ...model }
        if (viewModel.profilePhotoFileId) {
          viewModel.id = data.id;
          viewModel.profilePhotoFileId = data.profilePhotoFileId;
        }
        this.openModalService.openContactModal(viewModel, undefined, undefined, undefined, true, EntityTypeEnum.ImportEntity);
        break;
    }
  }

  importModels() {
    if (this.checkedValGet.length == 0) {
      Swal.fire({
        icon: 'warning',
        text: 'Please select record(s) to Import',
        color: 'var(--vz-body-color)',
        background: 'var(--vz-body-bg)',
        confirmButtonColor: '#299cdb',
      });
    } else {
      var multipleTypes: boolean = false;
      this.checkedValGet.forEach((model, index) => {
        if ((multipleTypes === false) && index > 0 && model.entityType != this.checkedValGet[index - 1].entityType) {
          multipleTypes = true;
        }
      })

      if (multipleTypes) {
        Swal.fire({
          icon: 'warning',
          text: 'Import type(s) selected must all be the same type',
          color: 'var(--vz-body-color)',
          background: 'var(--vz-body-bg)',
          confirmButtonColor: '#299cdb',
        });
      } else {
        this.importEntity(this.checkedValGet[0], this.checkedValGet);
      }
    }
  }

  importEntity(model: ImportEntityModel, modelArray?: ImportEntityModel[]) {

    if (modelArray == undefined) {
      modelArray = [];
      modelArray.push(model);
    }

    switch (model.entityType) {
      case EntityTypeEnum.Client:
        this.myFileApiService.newTaskClientImport().subscribe((newTaskModel: TaskModel | undefined) => {
          if (newTaskModel !== undefined) {
            this.taskModalService.openModal(newTaskModel, modelArray, "Import");
            var sub: Subscription = this.taskModalService.modelChanged.subscribe((result) => {
              this.serviceSort(this.importEntitiesListService, this.importEntitiesListService.sortColumnDirective, this.importEntitiesListService.sortDirection)
              sub.unsubscribe();
            })
          }
        });
        break;
      case EntityTypeEnum.Account:
        this.myFileApiService.newTaskContactImport().subscribe((newTaskModel: TaskModel | undefined) => {
          if (newTaskModel !== undefined) {
            this.taskModalService.openModal(newTaskModel, modelArray,"Import");
            var sub: Subscription = this.taskModalService.modelChanged.subscribe((result) => {
              this.serviceSort(this.importEntitiesListService, this.importEntitiesListService.sortColumnDirective, this.importEntitiesListService.sortDirection)
              sub.unsubscribe();
            })
          }
        });
        break;
    }
  }

}